import cn from 'client/utils/cn';

import React, { Component } from 'react';

import './index.css';

const b = cn('card');

interface Props {
    theme?: 'white' | 'blue';
    noPadding?: boolean;
    stretched?: boolean;
    type?: 'chart' | undefined;
}

class Card extends Component<Props> {
    render() {
        const { children, theme = 'blue', noPadding, stretched, type } = this.props;

        return (
            <div
                className={b(
                    '',
                    { theme, 'no-padding': noPadding, stretched, type }
                )}
                >
                {children}
            </div>
        );
    }
}

export default Card;
